import { render, staticRenderFns } from "./IconFilter.vue?vue&type=template&id=13006a22"
import script from "./IconFilter.vue?vue&type=script&lang=ts"
export * from "./IconFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports